import React from "react";
import { ActivityIndicator } from "react-native";
import { Typography, Divider, Box, Stack } from "digiwash-components";

import OrderItem from "../../components/OrderItem";
import SkeletonOrdersList from "../../components/SkeletonOrdersList";

interface PropTypes {
  data: any;
  isValidating: boolean;
  error: string;
  emptyText: string;
}

function OrdersCard(props: PropTypes) {
  let { isValidating, data, error, emptyText } = props;
  return (
    <>
      {isValidating && <SkeletonOrdersList />}
      {!isValidating && !!data ? (
        <>
          <Divider size="l" />
          {data.map((order) => {
            return (
              <React.Fragment key={order.id}>
                <OrderItem data={order} />
                <Divider size="xl" />
              </React.Fragment>
            );
          })}
        </>
      ) : null}
      {!isValidating && error ? (
        <Stack distribution="center">
          <Typography color="common.black">{error}</Typography>
        </Stack>
      ) : null}
      {emptyText && (
        <Box p="m">
          <Typography color="neutrals.700" ff="mainBold" alignment="center">
            {emptyText}
          </Typography>
        </Box>
      )}
    </>
  );
}

export default OrdersCard;
